import { api } from 'restaurantAdmin/api';
import { RestaurantStatus } from '../../shared/types/restaurants';

interface PacingControls {
  pacingLimit: number;
  pacingWindow: number;
}

export interface RestaurantMetadata {
  id: string;
  name: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  timezone: string;
  maxReservationGuests: number;
  coverLimit: number | null;
  pacingControls: PacingControls | null;
  availabilityInterval: number;
  locationSlug: string;
  nameSlug: string;
  supportEmail: string | null;
  trafficReportUrl: string | null;
  smsPhoneNumber: string | null;
  metabaseDashboardId: string | null;
  metabaseFinanceDashboardId: string | null;
  status: RestaurantStatus;
  neutralizationThreshold: number;
  minPriceThreshold: number;
  stripeConnectAccountId: string | null;
  lightspeedBusinessLocationId: string | null;
  isMlPricingEnabled: boolean;
  hotelIntegrationEnabled: boolean;
}

export type GuestTagCategory =
  | 'allergies'
  | 'custom'
  | 'dietary restrictions'
  | 'guest attributes'
  | 'other';

export interface GuestTag {
  category: GuestTagCategory;
  id: string;
  title: string;
  createdBy: string;
}

export const getAdminRestaurants = async (
  signal?: AbortSignal,
): Promise<RestaurantMetadata[]> => api.get('/admin/restaurants', { signal });

export const getRestaurantTags = async (
  restaurantId: string,
  signal?: AbortSignal,
): Promise<GuestTag[]> =>
  api.get(`/restaurants/${restaurantId}/tags`, { signal });
